var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "label",
      {
        staticClass: "boss-pulldown-menu",
        attrs: { for: "boss-bigpulldown-menu-item" },
      },
      [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedSortId,
                expression: "selectedSortId",
              },
            ],
            staticClass: "boss-pulldown-menu-item",
            attrs: {
              id: "boss-bigpulldown-menu-item",
              "data-test": "sort-select",
            },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedSortId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.sortItemMap, function (sortItem, i) {
            return _c(
              "option",
              {
                key: i,
                attrs: { "data-test": "sort-option-" + i },
                domProps: { value: sortItem.id.toString() },
              },
              [_vm._v("\n        " + _vm._s(sortItem.name) + "\n      ")]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }